var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"loader mx-5 float-end",class:_vm.position,style:({top: _vm.top, bottom: _vm.bottom, right: _vm.right, left: _vm.left}),attrs:{"src":require("@/assets/images/loader2.gif"),"alt":"","id":"loader"}})
}
var staticRenderFns = []

export { render, staticRenderFns }